import { BaseEntity, Column, CreateDateColumn, Entity, Index, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Grn } from "./grn.entity";
import { GrnInspection } from "./grn-inspection-enity";
import { AntibioticsTestStatus, PayablePaymentStatusEnum } from "@gtpl/shared-models/common-models";

@Entity("grn_items")

export class GrnItems {

    @PrimaryGeneratedColumn("increment", {
        name: "grn_item_id"
    })
    grnItemId: number;

    @Column("int", {
        name: "grn_id"
    })
    grnId: number;

    @Column("int", {
        name: "po_id"
    })
    poId: number;

    @Column("int", {
        nullable: false,
        name: "item_category_id"
    })
    itemCategoryId: number;

    @Column("int", {
        nullable: false,
        name: "item_sub_category_id"
    })
    itemSubCategoryId: number;

    @Column("int", {
        nullable: false,
        name: "item_id"
    })
    itemId: number;

    @Column("int", {
        nullable: true,
        name: "stock_id"
    })
    stockId: number;
    @Column("int", {
        nullable: true,
        name: "bulk_stock_id",
        default : 0
    })
    bulkStockId: number;
    
    @Column("int", {
        nullable: false,
        name: "size_id",
        default:0,
        comment: "size id not using"
    })
    sizeId: number;

    @Column("decimal", {
        nullable: false,
        name: "po_quantity"
    })
    poQuantity: number;


    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "accepted_quantity",
        default: 0,
        unsigned:true
    })
    acceptedQuantity: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "rejected_quantity",
        default: 0,
        unsigned:true
    })
    rejectedQuantity: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "received_quantity",
        default: 0,
        unsigned:true
    })
    receivedQuantity: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "returned_quantity",
        default: 0,
        unsigned:true
    })
    returnedQuantity: number;

    @Column({
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "unit_price",
        unsigned:true
    })
    unitPrice: number;

    @Column("decimal", {
        nullable: false,
        name: "actual_price"
    })
    actualPrice: number;

    @Column("decimal", {
        nullable: false,
        name: "discount_per"
    })
    discountPercentage: number;

    @Column("decimal", {
        nullable: false,
        name: "discount_amount"
    })
    discountAmount: number;

    @Column("decimal", {
        nullable: false,
        name: "tax_per"
    })
    taxPercentage: number;

    @Column("decimal", {
        nullable: false,
        name: "tax_amount"
    })
    taxAmount: number;

    @Column("decimal", {
        nullable: false,
        name: "tot_amount"
    })
    totalAmount: number;

    @Column("int", {
        //need to make it as nullable false
        nullable: true,
        name: "sale_order_id"
    })
    saleOrderId:number

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "status"
    })
    status: boolean | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("boolean", {
        nullable: false,
        default: false,
        name: "inspection_status"
    })
    inspectionStatus: boolean | null;

    @Column("int", {
        name: "inspected_qty"
    })
    inspectedQty: number;
     @Column({
            type: 'enum',
            enum: PayablePaymentStatusEnum,
            nullable: true,
            default: PayablePaymentStatusEnum.OPEN,
            name: 'payment_status'
        })
        paymentStatus: PayablePaymentStatusEnum;

    @Column('boolean',{
        name:'tds_applicable'
    })
    tdsApplicable : boolean

    @Column('decimal',{
        name:'taxable_amount',
        precision:10,scale:2
    })
    taxableAmount : number

 @Column('decimal',{
        name:'payment',
        precision:10,scale:2,
        default:0.00
    })
    payment : number
    @ManyToOne(type => Grn, grn => grn.grnItemsInfo, { nullable: false, })
    @JoinColumn({ name: "grn_id" })
    grnInfo: Grn[];
    
    @OneToMany(type => GrnInspection, grnItems => grnItems.grnitemId, { cascade: true })
    grninspection: GrnInspection[];


}

